import React, {createContext, useRef, useContext} from 'react';

const AudioContext = createContext();

export function AudioProvider({children}) {
  // Store the currently playing audio element
  const currentAudioRef = useRef(null);

  // Call this when an audio element is played
  const registerAudio = (audio) => {
    if(currentAudioRef.current && currentAudioRef.current !== audio) {
      currentAudioRef.current.pause();
    }
    currentAudioRef.current = audio;
  };

  // Call this when an audio element is paused or ends
  const unregisterAudio = (audio) => {
    if(currentAudioRef.current === audio) {
      currentAudioRef.current = null;
    }
  };

  return (
    <AudioContext.Provider value={{registerAudio, unregisterAudio}}>
      {children}
    </AudioContext.Provider>
  );
}

export function useAudioManager() {
  return useContext(AudioContext);
}


export function AudioPlayer({src, ...props}) {
  const {registerAudio, unregisterAudio} = useAudioManager();
  const ref = React.useRef();
  React.useEffect(() => {
    const audio = ref.current;
    if(!audio) return;
    const handlePlay = () => registerAudio(audio);
    const handlePause = () => unregisterAudio(audio);
    audio.addEventListener('play', handlePlay);
    audio.addEventListener('pause', handlePause);
    audio.addEventListener('ended', handlePause);
    return () => {
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('pause', handlePause);
      audio.removeEventListener('ended', handlePause);
    };
  }, [registerAudio, unregisterAudio]);
  return <audio ref={ref} controls {...props}><source src={src} type='audio/mp3' />Your browser does not support the audio element.</audio>;
}